import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchFees } from '../../../store/actions/feesActions';
import Pagination from '../../../components/elements/Pagination';
import EmptyState from '../../../components/elements/EmptyState';
import Loader from '../../../components/elements/Loader';
import FeeCard from '../../../components/partials/fees/FeeCard';
import PlusIcon from '../../../components/elements/icons/PlusIcon';
import ModalDialog from '../../../components/layouts/ModalDialog';
import NewFee from '../../../components/partials/fees/NewFee';
import EditFee from '../../../components/partials/fees/EditFee';

const Fees = () => {
  const dispatch = useDispatch()
  const feesSelector = useSelector(state => state.fees)
  const [reload, setReload] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  useEffect(() => {
    dispatch(fetchFees('', page, perPage))
    return () => {
      
    };
  }, [page, perPage, dispatch, reload]);

  const [creatingFee, setCreatingFee] = useState(false);
  const [editingFee, setEditingFee] = useState(false);
  const [activeFee, setActiveFee] = useState(null);

  const openFee = (fee) => {
    setActiveFee(fee)
    setTimeout(() => {
      setEditingFee(true)
    }, 50);
  }

  const closeFee = () => {
    setEditingFee(false)
    setTimeout(() => {
      setActiveFee(null)
    }, 50);
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full flex justify-between'>
          <div>
            <h3 className='text-lg font-medium'>Vaatia college fees </h3>
            <p className='text-sm'>All fees for vaatia college Makurdi. These fees can be tied to any students, applications, parents or requested for payment.</p>
          </div>
          <div>

            <button onClick={()=>{setCreatingFee(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
              <PlusIcon className='w-5 h-5' /> Create new fee
            </button>

          </div>
        </div>

        {feesSelector.loadingFees 
        ? 
        <Loader /> 
        :
        <>
          {feesSelector?.fees?.fees && feesSelector?.fees?.fees?.length > 0 
            ? 
              <>
                <div className='my-5 grid grid-cols-4 gap-[10px]'>
                  {feesSelector?.fees?.fees?.map((fee, feeIndex) => (
                    <div key={feeIndex}>
                      <FeeCard fee={fee} openFee={()=>{openFee(fee)}} />
                    </div>
                  ))}
                </div> 
                <Pagination 
                  pagination={{
                    perPage, 
                    page,
                    totalItems: feesSelector.fees.total,
                  }} 
                  changePage={setPage} 
                  updatePerPage={setPerPage}
                />
            </>
            : 
              <EmptyState emptyStateText='No fees have been created yet. Click on create new fee above to create a new one'></EmptyState>
          }
        </>}

      </div>

      <ModalDialog
        shown={creatingFee} 
        closeFunction={()=>{setCreatingFee(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create Fee`}
        dialogTitle='Create a new Fee'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
          <NewFee 
            description={`Create a new fee`} 
            reload={()=>setReload(reload+1)}
            closeFunction={()=>{setCreatingFee(false)}} 
          />

      </ModalDialog>

      {activeFee && <ModalDialog
        shown={editingFee} 
        closeFunction={()=>{closeFee()}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create Fee`}
        dialogTitle='Create a new Fee'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
          <EditFee 
            description={`Change the required details and save to update the fee`} 
            reload={()=>setReload(reload+1)}
            fee={activeFee}
            closeFunction={()=>{closeFee()}} 
          />

      </ModalDialog>}
    </>
  )
}

export default Fees